// ─────────────────────────────────────────────
// KLOTHIQ — Cash Account & Transaction Schemas
// ─────────────────────────────────────────────

import { z } from 'zod';
import { CashAccountType, CashTransactionType } from '@klothiq/domain';
import { moneySchema, moneyOrZeroSchema, dateSchema } from './common.schema';

export const cashAccountFormSchema = z.object({
  name: z.string().min(1, 'Account name is required').max(100),
  account_type: z.nativeEnum(CashAccountType),
  opening_balance: moneyOrZeroSchema,
  is_active: z.boolean().default(true),
});

export const cashTransferSchema = z.object({
  from_account_id: z.string().uuid('Select source account'),
  to_account_id: z.string().uuid('Select destination account'),
  amount: moneySchema.refine((val) => parseFloat(val) > 0, 'Amount must be greater than zero'),
  transfer_date: dateSchema,
  notes: z.string().max(500).nullable().optional(),
}).refine(
  (data) => data.from_account_id !== data.to_account_id,
  { message: 'Source and destination accounts must be different', path: ['to_account_id'] },
);

export const expenseFormSchema = z.object({
  account_id: z.string().uuid('Select a cash account'),
  amount: moneySchema.refine((val) => parseFloat(val) > 0, 'Amount must be greater than zero'),
  transaction_type: z.nativeEnum(CashTransactionType),
  expense_date: dateSchema,
  particular: z.string().min(1, 'Description is required').max(200),
  notes: z.string().max(500).nullable().optional(),
});

export type CashAccountFormValues = z.infer<typeof cashAccountFormSchema>;
export type CashTransferValues = z.infer<typeof cashTransferSchema>;
export type ExpenseFormValues = z.infer<typeof expenseFormSchema>;
